// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9e7ec89","926":"0f3a15f4"}[chunkId] + ".chunk.js";
};